




























































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { EntitiesTypes } from "@/data/enums/settings";
import { DataModules } from "@/store/modules/data";
import { OrgConfigKeys } from "@/data/constants";

// Types
import { IState } from "@/store";
import { IEntityCategory } from "@/models/settings";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      categories(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule,
          scope: this.categoriesScope
        });
      },
      categoriesScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/scope`](this.entity);
      },
      brandId(state: IState) {
        return state.brand.id;
      },

      orgProvisioningScope(state: IState, getters) {
        return getters[`data/${this.provisionDataModule}/orgProvisioning`];
      },
      orgProvisioning(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.provisionDataModule,
          scope: this.orgProvisioningScope
        });
      }
    })
  }
})
export default class SettingsDynamicCategoriesList extends Mixins(
  RequestPromises
) {
  // Refs
  public $refs!: {
    search: HTMLFormElement;
  };

  // Getters
  public categoriesScope!: string;
  public categories!: IEntityCategory[];
  public brandId!: IBrand["id"];
  public orgProvisioning!: boolean;
  public orgProvisioningScope!: string;

  // Props
  @Prop({ default: EntitiesTypes.BRAND })
  public entity!: string;

  @Prop({ default: () => [] })
  public routes!: any[];

  // Variables
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public contentIsAvailable = this.$userCan("list_settings");
  public guardFunctionalities = ["list_settings"];

  public dataModule: string = DataModules.SETTINGS_CATEGORIES;
  public provisionDataModule: DataModules = DataModules.PROVISIONING;
  public search = "";

  public created() {
    if (this.contentIsAvailable && this.brandId !== UUID.ORG) {
      this.isLoading = true;
      this.loadData();
    }
  }

  public async loadData() {
    try {
      await this.getEntityCategories();
      await this.getOrgProvisioning();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }

    this.$nextTick(() => {
      if (this.$_.has(this.$refs, "search.focus")) {
        this.$refs.search.focus();
      }
    });

    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getEntityCategories() {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      entity: this.entity,
      scope: this.categoriesScope,
      vm: this
    });
  }

  public getOrgProvisioning() {
    return this.$store.dispatch(
      `data/${this.provisionDataModule}/getOrgProvisioning`,
      {
        scope: this.orgProvisioningScope,
        vm: this,
        ignoreStored: false
      }
    );
  }

  public get isOrgProvisiongON() {
    return this.$_.get(
      this.orgProvisioning,
      OrgConfigKeys.PRODUCT_PROVISIONING_ENABLED,
      false
    );
  }

  public get filteredCategoriesGroups() {
    return this.$_.omitBy(
      this.$_.map(this.settingsGroups, (groupObj, gI) => {
        return this.$_.merge(
          {
            group: groupObj.group,
            routes: this.$_.orderBy(
              this.$_.pickBy(
                this.filteredCategories,
                (route: any) => route.groupId === gI
              ),
              ["order", "asc"]
            )
          },
          this.$_.get(groupObj, "requiresOrgProvisioning", false)
            ? { requiresOrgProvisioning: true }
            : {}
        );
      }),
      groupObj =>
        this.$_.isEmpty(groupObj.routes) ||
        (groupObj.requiresOrgProvisioning && !this.isOrgProvisiongON)
    );
  }

  public get filteredCategories() {
    return this.$_.filter(
      this.$_.concat(
        this.settingsGroups.flatMap((group, gI) =>
          this.$_.map(group.routes, route => {
            return {
              ...route,
              groupId: gI,
              isDisabled: !this.$userCan(...route.auth)
            };
          })
        ),
        this.miscellaneousCategories
      ),
      route => {
        if (!this.search.length) return true;
        return (
          route.name.toLowerCase().includes(this.search.toLowerCase()) ||
          route.description.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    );
  }

  public get miscellaneousCategories() {
    return this.$_.map(
      this.$_.filter(this.categories, category => {
        return !this.$_.find(
          this.settingsGroups.flatMap(group =>
            this.$_.map(group.routes, route => route)
          ),
          hardCodedCategory => hardCodedCategory.code === category.code
        );
      }),
      (filteredCategory: any) => {
        return this.$_.merge(
          {
            icon: "sliders-h",
            to: {
              name: "adminDynamicSettings",
              params: {
                settingId: this.$_.get(filteredCategory, "code")
              }
            }
          },
          {
            ...filteredCategory,
            groupId: this.settingsGroups.length - 1,
            isDisabled: this.$_.has(filteredCategory, "auth")
              ? !this.$userCan(this.$_.get(filteredCategory, "auth"))
              : false
          }
        );
      }
    );
  }

  public get settingsGroups(): any {
    return this.$_.orderBy(this.routes, ["order", "asc"]);
  }

  public highlight(needle, haystack) {
    return haystack
      ? haystack.replace(
          new RegExp(needle, "gi"),
          str => `<span class="has-text-info">${str}</span>`
        )
      : "";
  }

  public beforeDestroy() {
    this.$store.dispatch(`data/binList`, {
      storeModule: this.dataModule,
      scope: this.categoriesScope,
      vm: this
    });
  }
}
